import GentleWidget from '../common/widget';
import GentleComponentBubble from './bubble';

// 버튼
var GentleComponentButton = Object.create( GentleWidget );
GentleComponentButton.createComponent = function(option){
    // 객체리터럴, 배열리터럴 모두 지원 
    var buttons;

    if( Array.isArray(option) ){
        buttons = option;
    }else if(typeof option === 'object'){
        buttons = [];
        buttons.push(option);
    }
    
    // 컨테이너 생성후 자식요소 삽입 
    const {isCardWidth} = buttons[0];
    let cardViewWidth = '';
    if(isCardWidth) cardViewWidth = 'card-view-width';

    let htmlTop = `
    <div class="gentle-button-group ${cardViewWidth}">
    </div>`;
    var $buttonContainer = $(htmlTop);

    let type = 'wide-button';
    if(buttons.length > 1) type = 'half-button'
    let htmlButtons = `
    <div class="${type}">
    </div>`;
    var $buttons = $(htmlButtons);

    // $buttonContainer.addClass('button-container');

    for( let i=0; i<buttons.length; i++ ){
        const option = buttons[i];        
        if(option.text === undefined) throw new Error('버튼텍스트는 필수요소입니다');

        let buttonClass = 'primary default';
        if(option.isSecondary) buttonClass = 'secondary shadow';

        let {text, html} = option;
        html = html ? html : text; // html을 따로 지정한 경우 

        const $button = $(`<button class="${buttonClass}">${html}</button>`);

        // $button.text(option.text);

        if(option.onDisableAfterClick === true){
            $button.bind('click', function(){
                $(this).closest(".button-container").find("button").attr('disabled',true);
            });
        }

        // 자동사용자 발화가 디폴트
        if(option.isHidden){
            // 발화 안하기
            console.log('발화 안함');
        }
        else
        {
            const {text, send} = option;
            $button.bind('click', function(){
                GentleComponentBubble.insertUserBubble({html:text, send});                
            });
        }

        $buttons.append( $button );

        if(option.onClick !== undefined){
            $button.bind('click', option.onClick);
        }
    }
    $buttonContainer.append($buttons);
    
    this.setPrefix('button');
    this.init( $buttonContainer );
}

export default GentleComponentButton;